import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';

@Component({
  selector: `app-root`,
  templateUrl: `./app.component.html`,
  styleUrls: [ `./app.component.scss` ],
  imports: [
    NavbarComponent,
    RouterOutlet,
  ],
})
export class AppComponent {
  title = `flaggr`;
}
